import React, { Fragment, useCallback, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
// import SimpleBar from 'simplebar-react';

// import { AppContext } from '../contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { AFITD_WWW_DOMAIN_URL } from '../../system/constants';
import { CONFIRM_DIALOG_TITLE_CANCEL, CONFIRM_DIALOG_MESSAGE_CANCEL } from '../../common/constants';
import Logo from '../../system/Logo';
import AfitdButton from './AfitdButton';
import AfitdConfirmDialog from './AfitdConfirmDialog';

// import cx from 'clsx';
import _get from 'lodash/get';
// import _set from 'lodash/set';
// import _noop from 'lodash/noop';

const useStyles = (params = {}) => {
    const { hideActions, fullScreen } = params;

    return makeStyles(theme => ({
        root: {},
        appLogo: { width: 200, cursor: 'pointer' },
        labelContainer: fullScreen ? { width: '100%', textAlign: 'left' } : null,
        titleContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            fontFamily: 'Roboto, sans-serif',
            fontWeight: '600',
            textAlign: 'center',
        },
        closeIconButton: {
            width: '20px',
            height: '20px',
        },
        paperScrollPaper: {
            // overflowY: 'auto', //'visible', //'hidden',
            background: fullScreen ? '#FAFAFC' : '#fff',
        },
        content: {
            // overflowY: 'hidden', //'visible',
            ...(fullScreen ? null : { maxWidth: '640px' }),
            '&::-webkit-scrollbar-track': {
                // '-webkit-box-shadow': 'inset 0 0 1px rgba(0,0,0,0.1)',
                borderRadius: '10px',
                background: 'none',
            },
            '&::-webkit-scrollbar': {
                width: '8px',
                backgroundColor: '#F5F5F5',
            },
            '&::-webkit-scrollbar-thumb': {
                // '-webkit-box-shadow': 'inset 0 0 1px rgba(0,0,0,0.1)',
                borderRadius: '10px',
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
        },
        actionContainer: {
            display: hideActions ? 'none' : 'flex',
            justifyContent: 'space-between',
            width: '640px',
            padding: 16,
            // added
            [theme.breakpoints.down('sm')]: { flexDirection: 'column-reverse' },
        },
        rightActionContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            flexGrow: '2',
            marginRight: 10,
            // added
            [theme.breakpoints.down('sm')]: { flexDirection: 'column-reverse', marginRight: 0 },
        },
        clearAllButton: {
            margin: '0 4px',
            // added
            [theme.breakpoints.down('sm')]: { margin: 0 },
        },
        cancelButton: {
            marginRight: '16px',
            // backgroundColor: '#F0F2F6',
            // added
            [theme.breakpoints.down('sm')]: { margin: '8px 0px' },
        },
    }));
};

const getDefns = params => {
    const { props, classes, isConfirmCloseDialogOpen, setIsConfirmCloseDialogOpen, handleClickAppLogo } = params;
    const { actionButtonDefns, isDirty, onClose } = props;
    const cancelOnClick = _get(actionButtonDefns, 'cancel.onClick', handleClickCancelButton.bind(null, isDirty, setIsConfirmCloseDialogOpen, onClose));
    const clearAllButton = _get(actionButtonDefns, 'clearAll');
    const cancelButton = _get(actionButtonDefns, 'cancel');
    const saveButton = _get(actionButtonDefns, 'save');

    const cancelDisabled = _get(cancelButton, 'disabled', false); //_get(cancelButton, 'disabled', !isDirty);

    const defns = {
        root: {
            maxWidth: false,
            disableBackdropClick: true,
            disableEscapeKeyDown: true,
        },
        appLogo: { onClick: handleClickAppLogo },
        closeIconButton: {
            onClick: cancelOnClick,
        },
        clearAllButton: {
            ...clearAllButton,
        },
        cancelButton: {
            onClick: cancelOnClick,
            disabled: cancelDisabled,
            color: 'default',
            ...cancelButton,
        },
        saveButton: {
            color: 'primary',
            ...saveButton,
        },
        confirmCancelDialog: {
            title: CONFIRM_DIALOG_TITLE_CANCEL,
            open: isConfirmCloseDialogOpen,
            message: CONFIRM_DIALOG_MESSAGE_CANCEL,
            onConfirm: handleCloseConfirmCloseDialogYes.bind(null, onClose, setIsConfirmCloseDialogOpen),
            onClose: handleCloseConfirmCloseDialog.bind(null, setIsConfirmCloseDialogOpen),
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const handleCloseConfirmCloseDialog = setIsConfirmCloseDialogOpen => {
    setIsConfirmCloseDialogOpen(false);
};

const handleCloseConfirmCloseDialogYes = (onClose, setIsConfirmCloseDialogOpen) => {
    setIsConfirmCloseDialogOpen(false);
    onClose();
};

const handleClickCancelButton = (isDirty, setIsConfirmCloseDialogOpen, onClose) => {
    if (isDirty) {
        setIsConfirmCloseDialogOpen(true);
    } else {
        onClose();
    }
};

const AfitdEditDialog = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    // const appContext = useContext(AppContext);
    // const { authUser } = appContext;

    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [isConfirmCloseDialogOpen, setIsConfirmCloseDialogOpen] = useState(false);

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { label = '', actionButtonDefns, children, hideActions, ...otherProps } = props;
    const fullScreen = _get(props, 'fullScreen');
    const { setContentRef, isCloseable = true } = props;

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const clearAllButtonLabel = _get(actionButtonDefns, 'clearAll.label', 'Clear All');
    const cancelButtonLabel = _get(actionButtonDefns, 'cancel.label', 'Cancel');
    const saveButtonLabel = _get(actionButtonDefns, 'save.label', 'Save Changes');
    const isClearable = !!_get(actionButtonDefns, 'clearAll');

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);

    //---------------------------------------------------------------------
    // Event Handlers and useCallback
    //---------------------------------------------------------------------
    const getLabel = defns => {
        if (fullScreen) {
            return <Logo {...defns.appLogo} />;
        } else {
            return label;
        }
    };

    const handleClickAppLogo = useCallback(() => {
        window.open(`https://${AFITD_WWW_DOMAIN_URL}`);
    }, []);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const classes = useStyles({ fullScreen, hideActions })();
    const { paperScrollPaper: paperScrollPaperCls, content: contentCls } = classes;
    const defns = getDefns({ props, classes, isConfirmCloseDialogOpen, setIsConfirmCloseDialogOpen, handleClickAppLogo });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <Fragment>
            <Dialog {...defns.root} {...otherProps} classes={{ paperScrollPaper: paperScrollPaperCls }}>
                <DialogTitle>
                    <div {...defns.titleContainer}>
                        <div {...defns.labelContainer}>{getLabel(defns)}</div>
                        {isCloseable && (
                            <div {...defns.closeIconButtonContainer}>
                                <IconButton {...defns.closeIconButton}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                        )}
                    </div>
                </DialogTitle>
                <DialogContent className={contentCls} ref={setContentRef}>
                    {/* <div style={{ height: '300px' }}>
                    <SimpleBar style={{ height: '100%' }}>{children}</SimpleBar>
                </div> */}
                    {/* <SimpleBar>{children}</SimpleBar> */}
                    {children}
                </DialogContent>
                <DialogActions>
                    <div {...defns.actionContainer}>
                        {isClearable && <AfitdButton {...defns.clearAllButton}>{clearAllButtonLabel}</AfitdButton>}
                        <div {...defns.rightActionContainer}>
                            {isCloseable && <AfitdButton {...defns.cancelButton}>{cancelButtonLabel}</AfitdButton>}
                            <AfitdButton {...defns.saveButton}>{saveButtonLabel}</AfitdButton>
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
            <AfitdConfirmDialog {...defns.confirmCancelDialog} />
        </Fragment>
    );
};

export default AfitdEditDialog;
